module.exports = __webpack_public_path__ + "public/img/promo-3.0eb7f305.jpg";